// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__vrpDg","mainHeader":"Header_mainHeader__9o7YO","subHeader":"Header_subHeader__IaqPw"};